
<script setup>
    import iconStudent from '@/assets/images/result/ai/icon_student.png';
    import iconTeacher from '@/assets/images/result/ai/icon_teacher.png';
    import iconSchool from '@/assets/images/result/ai/icon_school.png';
    
    // 자료 카드용 이미지들
    import book2 from '@/assets/images/result/ai/book2.png';
    import book2_1 from '@/assets/images/result/ai/book2-1.png';
    import qr2 from '@/assets/images/result/ai/qr2.png';
    import qr2_1 from '@/assets/images/result/ai/qr2-1.png';
    import qrFrame from '@/assets/images/result/ai/qr_frame.svg';

    const props = defineProps({
        reportData: Object
    });

    console.log('📊 SchoolPage reportData:', props.reportData);
</script>
<template>
  <div class="report-inner">   
    <div class="card-wrap">
        <div class="card heatmap">
          <h5 class="card-title">「AI‧디지털 리터러시 진단검사」 결과, 이렇게 활용해요.</h5>
        </div>
        <div class="card mt-1">
          <div class="ai-table primary student-section mb-1">
            <div class="row">
                <div class="th col">
                    <div class="th">
                        <img :src="iconStudent" alt="학생 아이콘">
                        <span>학생</span>
                    </div>
                    <div class="th">                            
                        <p>현재 수준 이해</p>
                        <p>학습 방향 설정</p>
                        <p>맞춤형 보완 학습</p>
                    </div>
                </div>
                <div class="td">
                  <div class="td-content">
                      <ul>
                          <li>개인별 점수와 성취 수준에 대한 정보를 통해 학생들은 자신의 현재 AI·디지털 리터러시 수준을 객관적으로 이해</li>
                          <li>영역별 정답률을 통해 자신의 우수한 영역과 취약한 영역을 파악하고 향후 스스로 보완해야 할 학습 방향성 설정에 활용</li>
                          <li>결과지에 제공된 영역별 학습 조언과 추천 학습 자료를 활용하여 자기주도적 맞춤형 학습 실천</li>                                
                      </ul>                           
                  </div>
                </div>
              </div>
          </div>
          <div class="ai-table primary teacher-section mb-1">
            <div class="row">
                <div class="th col">
                    <div class="th">
                        <img :src="iconTeacher" alt="교사 아이콘">
                        <span>교사</span>
                    </div>
                    <div class="th">                            
                        <p>수준별 지도 계획</p>
                        <p>학급 특색 지도</p>
                        <p>수업 설계 반영</p>
                    </div>
                </div>
                <div class="td">
                  <div class="td-content">
                      <ul>
                          <li>학급 학생들을 성취 수준에 따라 분류하고 수준별 학생 비율과 명단을 활용하여, 세심한 지도가 필요한 학생을 위한 맞춤형 교육 계획 수립</li>
                          <li>학급과 학교 평균의 비교 분석을 통해 우리 학급만의 강점과 약점을 파악하고, 학급 특색에 맞는 지도 계획 수립</li>
                          <li>학급 내 낮은 영역을 분석하여 학생들의 수업계획에 활용</li>                               
                      </ul>                           
                  </div>
                </div>
              </div>
          </div>
          <div class="ai-table primary school-section mb-3">
            <div class="row">
                <div class="th col">
                    <div class="th">
                        <img :src="iconSchool" alt="학교 아이콘">
                        <span>학교</span>
                    </div>
                    <div class="th">                            
                        <p>교육과정 반영</p>
                        <p>교육 성장 지원</p>
                    </div>
                </div>
                <div class="td">
                  <div class="td-content">
                      <ul>
                          <li>학교 전체의 종합적인 성취 경향성을 파악하여 학교 AI·디지털 기반 교육과정의 내실을 검증하고, 결과 데이터를 교육목표 및 학교 교육계획에 반영</li>
                          <li>학급 간 비교 분석을 통해 학교 내 균형이 있는 교육성장을 위하여 학급별 맞춤형 지원과 교육 자원을 효율적으로 분배</li>                              
                      </ul>                           
                  </div>
                </div>
              </div>
          </div>
          <div class="card heatmap">
            <h5 class="card-title">AI‧디지털 리터러시 지도에 활용할 수 있는 자료는 무엇인가요?</h5>
          </div>
          
          <div class="resource-cards">
            <div class="resource-card">
              <h6 class="card-title">AI·디지털 기반 수업<br>실천 가이드북</h6>
              <hr class="divider">
              <div class="card-content">
                <div class="book-image">
                  <img src="@/assets/images/result/ai/book1.png" alt="가이드북 이미지">
                </div>
                <div class="qr-code">
                  <img src="@/assets/images/result/ai/qr1.png" alt="QR코드">
                </div>
                <div class="url">
                  <a href="#" target="_blank">https://m.site.naver.com/215Ac</a>
                </div>
              </div>
            </div>
            
            <div class="resource-card">
              <h6 class="card-title">AI·디지털 역량 교육<br>주간 도움자료집</h6>
              <hr class="divider">
              <div class="card-content">
                <div class="book-image">
                  <img :src="props.reportData?.classList[0]?.schul_type === 'M' ? book2_1 : book2" alt="가이드북 이미지">
                </div>
                <div class="qr-code">
                  <img :src="props.reportData?.classList[0]?.schul_type === 'M' ? qr2_1 : qr2" alt="QR코드">
                </div>
                <div class="url">
                  <a :href="props.reportData?.classList[0]?.schul_type === 'M' ? 'https://m.site.naver.com/20GPQ' : 'https://m.site.naver.com/20GQ5'" target="_blank">
                    {{ props.reportData?.classList[0]?.schul_type === 'M' ? 'https://m.site.naver.com/20GPQ' : 'https://m.site.naver.com/20GQ5' }}
                  </a>
                </div>
              </div>
            </div>
            
            <div class="resource-card">
              <h6 class="card-title">초·중·고 디지털<br>시민성 교육자료</h6>
              <hr class="divider">
              <div class="card-content">
                <div class="book-image">
                  <img src="@/assets/images/result/ai/book3.png" alt="가이드북 이미지">
                </div>
                <div class="qr-code">
                  <img src="@/assets/images/result/ai/qr3.png" alt="QR코드">
                </div>
                <div class="url">
                  <a href="#" target="_blank">https://m.site.naver.com/215AI</a>
                </div>
              </div>
            </div>
            
            <div class="resource-card">
              <h6 class="card-title">AI·디지털 기반<br>교육학습자료</h6>
              <hr class="divider">
              <div class="card-content">
                <div class="book-image">
                  <img src="@/assets/images/result/ai/book4.png" alt="가이드북 이미지">
                </div>
                <div class="qr-code">
                  <img src="@/assets/images/result/ai/qr4.png" alt="QR코드">
                </div>
                <div class="url">
                  <a href="#" target="_blank">https://m.site.naver.com/219am</a>
                </div>
              </div>
            </div>
          </div>



          <div class="card heatmap">
            <h5 class="card-title">「AI‧디지털 리터러시 진단검사」 결과, 이렇게 만들어집니다.</h5>
          </div>
          <div class="ai-table primary student-section mb-3">
            <div class="row">
              <div class="th col">
                <div class="th" style="display:none">
                    
                </div>
                <div class="th">                            
                    <p>다각도 성취 분석</p>
                    <p>개인별 맞춤 지원</p>
                    <p>전문가 수준 결정</p>
                </div>
              </div>
              <div class="td">
                <div class="td-content">
                  <ul>
                    <li>진단검사가 시행된 후 원점수를 기반으로 학생/학급/학교별 평균 및 영역별 성취율을 산출합니다.</li>
                    <li>진단검사 오답과 문항의 난이도를 정밀하게 분석하여 학생별 최적화된 학습 자료를 매칭합니다.</li>
                    <li>전문가 집단의 분석을 통해 설정된 수준 준거에 따라 학생의 최종 성취 수준을 확정합니다.</li>                                
                  </ul>                           
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ai-table {
    .row div.th.col {
        padding: 0;
       display: flex;  
        &::before { display: none; }
        .th { 
            position: relative;
            padding: 1rem 0 1rem 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 200px;
            height: 100%;
            min-width: auto;
            &::before {
                content: "";
                position: absolute;
                background-color: var(--result-ai-primary-100);
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                width: 1px;
                height: calc(100% - 10px);
            }
            &:nth-child(1) { 
                font-weight: 600; 
                text-align: center; 
                width: 150px;
                flex-direction: column;
                gap: 0.5rem;
                
                img {
                    width: 40px;
                    height: 40px;
                }
                
                span {
                    font-size: 1rem;
                }
            }
            &:nth-child(2) { 
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 180px;
                p { font-weight: 600; color: var(--result-ai-primary-800); font-size: 19px; }
            }
        }  
    }
    .td {
        padding: 1rem .5rem 1rem 1rem !important;
        line-height: 1.5;
        text-align: justify;
        word-break: keep-all;
        text-justify: inter-word;
         > ul {
            li { 
            position: relative;
            padding-left: 24px;
            font-size: 16px;
            &::before {
                content: '';
                position: absolute;
                left: 10px;
                top: 11px;
                width: 3px;
                height: 3px;
                background-color: var(--result-ai-blak);
                border-radius: 50%;       
                }
            }
        }
        .qr-area {
            padding: 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            p { text-align: center; font-weight: 600; color: var(--result-ai-primary-800); }
            a { 
                font-size: 1rem; 
                color: var(--result-ai-primary-500);
                display: inline-block;
                text-decoration: underline;
                text-underline-offset: 3px;
                margin-top: 0.5rem;
            }
            .qr-placeholder {
                position: relative;
                width: 162px;
                height: 232px;
                .qr-img {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    img {
                        margin-top: 40px;
                        width: 109px;
                        height: 111px;
                    }
                }
            }
            &::before {
                content: "";
                position: absolute;
                background-color: var(--result-ai-primary-100);
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 1px;
                height: calc(100% - 10px);
            }
        }
    }
    // 3개 영역 (학생, 교사)
    &.student-section .row,
    &.teacher-section .row {
        .th {
            &:nth-child(2) { 
                padding: 0 !important; 
                &::before { display: none; }            
            }           
            p { 
                position: relative;
                width: 100%;
                height: 33.33%;
                display: flex;
                align-items: center;
                justify-content: center;               
                &::before {
                    content: "";
                    position: absolute;
                    background-color: var(--result-ai-primary-100);
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    width: 1px;
                    height: calc(100% - 10px);
                }
                &::after {
                    content: "";
                    position: absolute;
                    background-color: var(--result-ai-primary-100);
                    right : 0;
                    bottom: 0;
                    width: calc(100% - 10px);
                    height: 1px;
                }
                &:last-child::after { display: none; }
            }
        }
        .td { 
            display: flex; padding: 0 !important;  
            height: 200px;           
            .td-content {
                ul {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    width: 100%;
                    li { 
                        height: 33.33%;
                        display: flex;
                        align-items: flex-start;
                        justify-content: center;
                        flex-direction: column;
                        padding: .3rem 0.8rem;
                        position: relative;
                        line-height: 1.3;
                        width: 100%;
                        text-align: justify;
                        &::after {
                            content: "";
                            position: absolute;
                            background-color: var(--result-ai-primary-100);
                            left : 0;
                            bottom: 0;
                            width: calc(100% - 10px);
                            height: 1px;
                        }
                        &:last-child::after { display: none; }
                        a { 
                            font-size: 1rem; 
                            color: var(--result-ai-primary-500);
                            display: inline-block;
                            text-decoration: underline;
                            text-underline-offset: 3px;
                         }
                    }
                }
            }
        }
    }
    
    // 2개 영역 (학교)
    &.school-section .row {
        .th {
            &:nth-child(2) { 
                padding: 0 !important; 
                &::before { display: none; }            
            }           
            p { 
                position: relative;
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;
                justify-content: center;               
                &::before {
                    content: "";
                    position: absolute;
                    background-color: var(--result-ai-primary-100);
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    width: 1px;
                    height: calc(100% - 10px);
                }
                &::after {
                    content: "";
                    position: absolute;
                    background-color: var(--result-ai-primary-100);
                    right : 0;
                    bottom: 0;
                    width: calc(100% - 10px);
                    height: 1px;
                }
                &:last-child::after { display: none; }
            }
        }
        .td { 
            display: flex; padding: 0 !important;  
            height: 140px;           
            .td-content {
                ul {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    li { 
                        height: 50%;
                        display: flex;
                        align-items: flex-start;
                        justify-content: center;
                        flex-direction: column;
                        padding: .3rem 0.8rem;
                        position: relative;
                        line-height: 1.3;
                        &::after {
                            content: "";
                            position: absolute;
                            background-color: var(--result-ai-primary-100);
                            left : 0;
                            bottom: 0;
                            width: calc(100% - 10px);
                            height: 1px;
                        }
                        &:last-child::after { display: none; }
                        a { 
                            font-size: 1rem; 
                            color: var(--result-ai-primary-500);
                            display: inline-block;
                            text-decoration: underline;
                            text-underline-offset: 3px;
                         }
                    }
                }
            }
        }
    }
    .row.thead div.th.col .th {
        &::before {
            width: 2px !important;
            height: 100% !important;
        }
    }    
}

.resource-cards {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
    
    .resource-card {
        flex: 1;
        background: var(--smoe-white);
        border: 1px solid var(--result-ai-primary-100);
        border-radius: 8px;
        padding: 0.5rem 1rem;
        text-align: center;
        
        .card-title {
            font-size: 1rem;
            font-weight: 600;
            color: var(--result-ai-primary-800);
            margin-bottom: 0.5rem;
            line-height: 1.4;
        }
        
        .divider {
            border: none;
            border-top: 1px solid var(--result-ai-primary-200);
            
        }
        
        .card-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.5rem;
            
            .book-image {
                width: 160px;
                height: 190px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--result-ai-primary-50);
                border-radius: 4px;
                
                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }
            }
            
            .qr-code {
                width: 160px;
                height: 160px;
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            
            .url {
                a {
                    font-size: 0.75rem;
                    color: var(--result-ai-primary-500);
                    text-decoration: underline;
                    text-underline-offset: 2px;
                    word-break: break-all;
                    line-height: 1.2;
                }
            }
        }
    }
}
</style>